import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import Layout from './Layout';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import WhatWeDo from './pages/WhatWeDo/WhatWeDo';
import Projects from './pages/Project/Projects';
import ProjectDetails from './pages/ProjectDetails/ProjectDetails';
import Blog from './pages/Blog/Blog';
import BlogDetails from './pages/BlogDetails/BlogDetails';
import Contact from './pages/Contact/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions/TermsConditions';
import AgriculturalLands from './components/PropertyCategory/AgriculturalLands/AgriculturalLands';
import Apartments from './components/PropertyCategory/Apartments/Apartments';
import CommercialPlots from './components/PropertyCategory/CommercialPlots/CommercialPlots';
import ResidentialPlots from './components/PropertyCategory/ResidentialPlots/ResidentialPlots';
import Villas from './components/PropertyCategory/Villas/Villas';
import BuySellProperties from './pages/Services/BuySellProperties/BuySellProperties';
import PropertyManagement from './pages/Services/PropertyManagement/PropertyManagement';
import MarketingManagement from './pages/Services/MarketingManagement/MarketingManagement';
import RealEstateInvestment from './pages/Services/RealEstateInvestment/RealEstateInvestment';
import ConstructionDevelopment from './pages/Services/ConstructionDevelopment/ConstructionDevelopment';
import RentalServices from './pages/Services/RentalServices/RentalServices';

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="whatwedo" element={<WhatWeDo />} />
          <Route path="projects" element={<Projects />} />
          <Route path="projects/details" element={<ProjectDetails />} />
          <Route path="blog" element={<Blog />} />
          <Route path="blog/details" element={<BlogDetails />} />
          <Route path="contact" element={<Contact />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="terms-conditions" element={<TermsConditions />} />

          {/* Category Pages */}
          <Route path="agricultural-lands" element={<AgriculturalLands />} />
          <Route path="apartments" element={<Apartments />} />
          <Route path="commercial-plots" element={<CommercialPlots />} />
          <Route path="residential-plots" element={<ResidentialPlots />} />
          <Route path="villas" element={<Villas />} />

          {/* Service Pages */}
          <Route path="buy-sell-properties" element={<BuySellProperties />} />
          <Route path="property-management" element={<PropertyManagement />} />
          <Route path="marketing-management" element={<MarketingManagement />} />
          <Route path="real-estate-investment" element={<RealEstateInvestment />} />
          <Route path="construction-development" element={<ConstructionDevelopment />} />
          <Route path="rental-services" element={<RentalServices />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
